import React from 'react';
import ReactDOM from 'react-dom/client';
import {WebStorageStateStore} from 'oidc-client-ts';
import {AuthProvider} from 'react-oidc-context';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppWrapper from './AppWrapper';

const host = window.location.origin;
const config = {
  authority: process.env.REACT_APP_AUTH_AUTHORITY,
  client_id: process.env.REACT_APP_AUTH_CLIENTID,
  client_secret: process.env.REACT_APP_AUTH_CLIENTSECRET,
  redirect_uri: `${host}/`,
  post_logout_redirect_uri: `${host}/silent-renew.html`,
  post_logout_redirect_uri: `${host}/`,
  response_type: 'code',
  scope: process.env.REACT_APP_AUTH_SCOPE,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({store: window.localStorage}),
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...config}>
      <AppWrapper />
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
